import { createFileRoute, Outlet } from '@tanstack/react-router'

import useAuthStore from '@/store/useAuthStore'

export const Route = createFileRoute('/_auth/timetable')({
  component: () => <Outlet />,
  onEnter: useAuthStore.getState().refetchUser
})
